import { Button, Spinner } from "react-bootstrap";
import {
  ArrowCounterclockwise as RotateCcw,
  Check,
  Pencil,
  X,
  Arrow90degLeft,
} from "react-bootstrap-icons";
import { ActionButton } from "../../shared";

/**
 * Inline row actions.
 * Non-finalized rows: Approve + icon actions.
 * Approved / paid rows collapse to a single Reopen button.
 */
export function RecordActions({
  isFinalized,
  onApprove,
  onAdjust,
  onReject,
  onRemove,
  onReopen,
  isApproving = false,
  isRemoving = false,
  isDisabled = false,
}) {
  const hasHandler = (fn) => typeof fn === "function";
  const isBusy = isApproving || isRemoving || isDisabled;

  if (isFinalized) {
    if (!hasHandler(onReopen)) {
      return <span className="text-muted small">Locked</span>;
    }

    return (
      <ActionButton
        text="Reopen"
        variant="outline-secondary"
        onClick={onReopen}
        disabled={isBusy}
        icon={<RotateCcw size={12} />}
        isLoading={isApproving}
      />
    );
  }

  const showAdjust = hasHandler(onAdjust);
  const showReject = hasHandler(onReject);
  const showApprove = hasHandler(onApprove);
  const showRemove = hasHandler(onRemove);

  if (!showAdjust && !showReject && !showApprove && !showRemove) {
    return <span className="text-muted small">No actions</span>;
  }

  return (
    <div className="record-actions">
      {showApprove && (
        <Button
          variant="link"
          size="sm"
          onClick={onApprove}
          className="record-action-icon-btn"
          disabled={isBusy}
          title="Approve"
          aria-label="Approve"
        >
          {isApproving ? (
            <Spinner
              animation="border"
              as="span"
              size="sm"
              aria-hidden="true"
              style={{ width: 14, height: 14, borderWidth: 2 }}
            />
          ) : (
            <Check size={16} />
          )}
        </Button>
      )}

      {showAdjust && (
        <Button
          size="sm"
          variant="link"
          onClick={onAdjust}
          className="record-action-icon-btn"
          title="Adjust amount"
          aria-label="Adjust amount"
          disabled={isBusy}
        >
          <Pencil size={16} />
        </Button>
      )}

      {showReject && (
        <Button
          size="sm"
          variant="link"
          onClick={onReject}
          className="record-action-icon-btn"
          title="Decline"
          aria-label="Decline"
          disabled={isBusy}
        >
          <X size={16} />
        </Button>
      )}

      {showRemove && (
        <Button
          size="sm"
          variant="link"
          onClick={onRemove}
          className="record-action-icon-btn"
          title="Return to pool"
          aria-label="Return to pool"
          disabled={isBusy}
        >
          {isRemoving ? (
            <Spinner
              animation="border"
              as="span"
              size="sm"
              aria-hidden="true"
              style={{ width: 14, height: 14, borderWidth: 2 }}
            />
          ) : (
            <Arrow90degLeft size={16} />
          )}
        </Button>
      )}
    </div>
  );
}
